import { canv } from '@/canv/global.js'

import { emoteVis } from '@/animations/emote.js'

export class animator {

    constructor() {

    }

    draw() {
        for (var i = 0; i < this.animations.length; i++) {
            this.animations[i].draw();
        }
    }


    step() {
        for (var i = 0; i < this.animations.length; i++) {
            if (this.animations[i].finished) {
                this.animations.splice(i, 1);
                i--;
                continue;
            }
            this.animations[i].step();
        }
    }

    frame() {
        this.draw();
        this.step();
    }

    isEmpty() {
        return this.animations.length == 0;
    }

    addAnimation(animation) {
        this.animations.push(animation);
    }

    hasAnimation(name) {
        for (var i = 0; i < this.animations.length; i++) {
            if (this.animations[i].name == name) {
                return true;
            }
        }

        return false;
    }

    deleteAnimation(name) {
        for (var i = 0; i < this.animations.length; i++) {
            if (this.animations[i].name == name) {
                this.animations.splice(i, 1);
                i--;
            }
        }
    }

    createEmote(data) {
        var emot = new emoteVis(data["x"], data["y"], data["url"]);
        canv.animator.addAnimation(emot);
    }


    animations = [];
}